import Application from "../../Application";
import AttributeCodebookPresenter, {
  IAttributeCodebookPresenter
} from "../../presenter/valuelist/AttributeCodebookPresenter";
import { IValueListService } from "../../service/valuelist/ValueListService";

export default class ShowAttributeCodebookInteractor {
  private application: Application;
  private valueListService: IValueListService;
  private output?: IAttributeCodebookPresenter;

  constructor(application, valueListService) {
    this.application = application;
    this.valueListService = valueListService;
  }

  execute() {
    this.output = AttributeCodebookPresenter({
      application: this.application,
      initialState: { attributeCodeList: [], attributeModalVisible: false }
    });

    this.valueListService
      .getValueListLabels()
      .then(this.output && this.output.loadAttributeCodeList);

    return this.output;
  }
}
